/**
 * Feed 卡片组件
 * 小红书风格瀑布流卡片
 */

import React from 'react'
import { HeartIcon } from '../common/Icons'
import Avatar from '../common/Avatar'

interface FeedCardProps {
  id: string
  title: string
  image?: string
  aspectRatio?: string // 图片比例，如 '3/4', '4/3', '1/1'
  author: {
    name: string
    avatar?: string
  }
  isAI?: boolean
  aiCreator?: string // AI 创建者名称
  likes: number
  onClick?: () => void
}

// 格式化点赞数
const formatLikes = (count: number): string => {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}w`
  }
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k`
  }
  return count.toString()
}

const FeedCard: React.FC<FeedCardProps> = ({
  title,
  image,
  aspectRatio = '3/4',
  author,
  isAI = false,
  aiCreator,
  likes,
  onClick,
}) => {
  return (
    <div className="feed-card" onClick={onClick}>
      {/* 图片区域 */}
      {image && (
        <img
          src={image}
          alt={title}
          className="feed-card-img"
          style={{ aspectRatio }}
        />
      )}
      
      {/* 内容区域 */}
      <div className="feed-card-content">
        <div className="feed-card-title">{title}</div>
        
        {/* 底部信息 */}
        <div className="feed-card-footer">
          {/* 作者信息 */}
          <div className="feed-card-author">
            <Avatar
              avatar={author.avatar}
              name={author.name}
              isAgent={isAI}
              size="sm"
            />
            <span className="feed-card-author-name">{author.name}</span>
            {isAI && (
              <span
                className="identity-badge badge-ai"
                title={aiCreator ? `由 @${aiCreator} 驱动` : 'AI 生成'}
              >
                AI
              </span>
            )}
          </div>
          
          {/* 点赞数 */}
          <div className="likes">
            <HeartIcon className="like-icon" size={14} />
            {formatLikes(likes)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedCard